import * as R from "ramda";

import {
  UPDATE_COMPANY_PROFILE,
  FETCH_COMPANY_PROFILE,
  FETCH_COMPANY_USERS,
  DELETE_COMPANY_USER,
  SELECT_COMPANY,
  CONNECT_COMPANY_SOCIAL_ACCOUNT,
  DISCONNECT_COMPANY_SOCIAL_ACCOUNT,
  LINK_TO_COMPANIES
} from "../actions/company";
import { FETCH_COMPANIES } from "../actions/companies";
import { FETCH_HEADQUARTER } from "../actions/headquarter";
import { UPDATE_CANDIDATE_TAGS } from "../actions/opportunity";

export const initialState = {};

const company = (state = initialState, { type, payload }) => {
  switch (type) {
    case CONNECT_COMPANY_SOCIAL_ACCOUNT.STARTED:
      return R.assocPath(["socialAccounts", "loading"], payload.provider)(
        state
      );

    case DISCONNECT_COMPANY_SOCIAL_ACCOUNT.STARTED:
      return R.assocPath(["socialAccounts", "loading"], payload)(state);
    case DISCONNECT_COMPANY_SOCIAL_ACCOUNT.REJECTED:
    case CONNECT_COMPANY_SOCIAL_ACCOUNT.REJECTED:
      return R.assocPath(["socialAccounts", "loading"], null)(state);
    case UPDATE_COMPANY_PROFILE.RESOLVED:
    case CONNECT_COMPANY_SOCIAL_ACCOUNT.RESOLVED:
    case DISCONNECT_COMPANY_SOCIAL_ACCOUNT.RESOLVED:
    case FETCH_COMPANY_PROFILE.RESOLVED:
    case LINK_TO_COMPANIES.RESOLVED:
      return {
        ...state,
        ...payload
      };
    case FETCH_COMPANY_USERS.RESOLVED:
      return {
        ...state,
        users: payload
      };
    case DELETE_COMPANY_USER.STARTED:
      return {
        ...state,
        users: R.map(
          user => (user.id === payload ? { ...user, loading: true } : user),
          state.users
        )
      };
    case DELETE_COMPANY_USER.RESOLVED:
      return {
        ...state,
        users: R.reject(user => user.id === payload.id, state.users)
      };
    case SELECT_COMPANY.TYPE:
      return payload;
    case FETCH_HEADQUARTER.STARTED:
    case FETCH_COMPANIES.STARTED:
      // TODO revise
      return state;
    case UPDATE_CANDIDATE_TAGS.RESOLVED:
      const { addTags } = payload;
      return {
        ...state,
        tags: R.union(state.tags || [], addTags || [])
      };
    default:
      return state;
  }
};

export default company;
